import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../config/firebase";
import MovieCard from "../Components/MovieCard";
import Background from "../Components/Background";
import { useNavigate } from "react-router-dom";
import Loading from "../Components/Loading";

const List = ({ home }) => {
  const [allLists, setAllLists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOption, setSortOption] = useState("largest");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAllLists = async () => {
      try {
        const usersCollection = collection(db, "users");
        const querySnapshot = await getDocs(usersCollection);
        const allUserLists = [];

        querySnapshot.forEach((userDoc) => {
          const userData = userDoc.data();
          const userLists = userData.profile?.lists || [];

          userLists.forEach((list) => {
            allUserLists.push({
              ...list,
              name: userData.profile?.name,
            });
          });
        });

        setAllLists(allUserLists);
      } catch (error) {
        console.error("Error fetching all lists:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllLists();
  }, []);

  if (loading)
    return (
      <div>
        <div className="z-40">
          <Loading />
        </div>
        <Background />
      </div>
    );

  // --- filter & sort ---
  let filteredLists = allLists.filter((list) =>
    list.listName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (sortOption === "largest") {
    filteredLists = [...filteredLists].sort(
      (a, b) => b.items.length - a.items.length
    );
  } else if (sortOption === "smallest") {
    filteredLists = [...filteredLists].sort(
      (a, b) => a.items.length - b.items.length
    );
  } else if (sortOption === "name") {
    filteredLists = [...filteredLists].sort((a, b) =>
      a.listName.localeCompare(b.listName)
    );
  }

  const displayedLists = home ? filteredLists.slice(0, 4) : filteredLists;

  return (
    <div className="px-4">
      {home ? (
        <div className="bg-yellow-900 p-2 md:p-5 rounded-md bg-opacity-10 border my-8 border-gray-700">
          <div className="newfont relative z-30 mx-5 text-center text-transparent bg-gradient-to-r from-slate-200/90 to-slate-400/90 bg-clip-text font-extrabold text-lg md:text-xl lg:text-xl 2xl:text-3xl ">
            Explore what’s trending List
          </div>
        </div>
      ) : (
        <div className="mt-9 z-40 relative newfont uppercase mb-1 text-lg font-extrabold md:text-xl lg:text-2xl 2xl:text-4xl text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text w-full flex justify-center items-center">
          Lists
        </div>
      )}
      {!home && (
        <div className="newfont flex relative z-40 flex-row items-center justify-center mb-4 gap-2 p-2 rounded-md">
          <input
            type="text"
            placeholder="Explore the lists..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="px-3 py-2 border rounded-md text-sm w-full md:w-1/3 bg-gray-700 border-yellow-600 placeholder-gray-400 text-white focus:ring-yellow-400"
          />
          <select
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
            className="px-3 py-2 border rounded-md text-sm bg-gray-700 border-yellow-600 placeholder-gray-400 text-white focus:ring-yellow-400"
          >
            <option value="largest">Largest first</option>
            <option value="smallest">Smallest first</option>
            <option value="name">Name A-Z</option>
          </select>
        </div>
      )}

      {displayedLists.length > 0 ? (
        displayedLists.map((list) => (
          <div
            key={list.listId}
            className="list-container z-40 px-4 relative bg-yellow-900 rounded-md bg-opacity-10 border my-8 border-gray-700"
          >
            <div className="flex flex-col px-4">
              <div className="flex flex-row w-full items-center justify-between">
                <div className="newfont uppercase mb-1 text-sm md:text-md lg:text-lg 2xl:text-2xl inline-block text-transparent bg-gradient-to-r from-amber-400/90 to-yellow-400/90 bg-clip-text ">
                  {list.listName}
                  <span className="text-xs text-gray-400">
                    ({list.items.length} items)
                  </span>
                </div>
                <button
                  className="hover:text-yellow-400 rounded text-xs px-2 py-1 text-slate-50"
                  onClick={() => navigate("/listView", { state: list })}
                >
                  See More
                </button>
              </div>
              <hr className="h-px bg-gray-200 border-0 dark:bg-gray-700" />
            </div>

            <div className="flex relative overflow-x-hidden space-x-4">
              {list.items.map((e, index) => (
                <div
                  key={e.id || index}
                  className="hover:z-50"
                  style={{ marginLeft: index === 0 ? "0px" : "-90px" }}
                >
                  <MovieCard
                    movie={{
                      name: e.name,
                      id: e.tvid || e.movieid,
                      profile_path: e.posterImage,
                    }}
                    filterType={
                      e.movieid
                        ? { isMovieChecked: true }
                        : { isTvChecked: true }
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        ))
      ) : (
        <p className="newfont relative z-50 text-center text-gray-300 mt-8 text-lg md:text-xl">
          Can't find what you're looking for? Why not start creating your own
          awesome list!
        </p>
      )}
      {!home && <Background />}
    </div>
  );
};

export default List;
